var map = {
	"./404.svg": 955,
	"./Categories.png": 956,
	"./Edit-menu.svg": 957,
	"./Egg.svg": 958,
	"./Emaier-Header.png": 959,
	"./Qr-4.png": 960,
	"./_duplicate.svg": 961,
	"./_overview.svg": 962,
	"./add-white.svg": 963,
	"./alert.svg": 964,
	"./all_category.svg": 965,
	"./archive.svg": 966,
	"./armchair.svg": 967,
	"./arrow-circle-right.svg": 968,
	"./arrow-left-circle.svg": 969,
	"./arrow-right-circle.svg": 970,
	"./arrow-right.svg": 971,
	"./asc-up-white.svg": 972,
	"./asc.png": 973,
	"./asc.svg": 974,
	"./back-arrow.svg": 975,
	"./barcode-icon.svg": 976,
	"./beverages.svg": 977,
	"./blue-edit-pen.svg": 978,
	"./blue-eye.svg": 979,
	"./box-office.svg": 980,
	"./broken-seat.jpg": 981,
	"./calendar_list.svg": 982,
	"./calender.svg": 364,
	"./chevron-down.svg": 983,
	"./chevron-left.svg": 984,
	"./cinema-mamagement-sidebar.svg": 985,
	"./claendar.svg": 314,
	"./clock-1.svg": 986,
	"./clock.svg": 987,
	"./close-button.svg": 718,
	"./close-white.svg": 720,
	"./close-x.svg": 309,
	"./collapse-up.svg": 988,
	"./collapse.svg": 989,
	"./connection-lost.svg": 362,
	"./consumable-raw-material.svg": 990,
	"./copy.svg": 991,
	"./copy_image_icon.png": 992,
	"./delete-red-light.svg": 993,
	"./delete-red.svg": 727,
	"./delete.svg": 701,
	"./deliver-icon.svg": 994,
	"./desc-down-white.svg": 995,
	"./desc.svg": 996,
	"./distributors-sidebar.svg": 997,
	"./download.svg": 998,
	"./dragndrop.svg": 999,
	"./dragndrop2.svg": 1000,
	"./duplicate.svg": 1001,
	"./duplicateScreen.svg": 1002,
	"./e-wallet-icon-black.svg": 1003,
	"./edit-pen-blue.svg": 1004,
	"./edit-pen-white.svg": 1005,
	"./edit-pen.svg": 1006,
	"./edit.svg": 1007,
	"./email.png": 1008,
	"./empty-image.svg": 1009,
	"./excel.svg": 1010,
	"./external-link.svg": 1011,
	"./eye.svg": 1012,
	"./filter-icon.svg": 1013,
	"./flag.svg": 1014,
	"./fnb-app-order.svg": 1015,
	"./fnb-beverages.svg": 1016,
	"./fnb-brownie.svg": 1017,
	"./fnb-combo.svg": 1018,
	"./fnb-desert.svg": 1019,
	"./fnb-eatables.svg": 1020,
	"./fnb-make-your-combo.svg": 1021,
	"./fnb-popcorn.svg": 1022,
	"./fnbtransactionIcon.svg": 1023,
	"./fullscreen-icon.svg": 728,
	"./funnel.svg": 1024,
	"./globe.svg": 1025,
	"./green-tick.svg": 1026,
	"./grid-view.svg": 1027,
	"./hide-password.svg": 365,
	"./home-icon.svg": 1028,
	"./home.svg": 1029,
	"./icon-black-play.svg": 1030,
	"./icon-dot.svg": 1031,
	"./icon-fnb.svg": 1032,
	"./icon-marketing.svg": 1033,
	"./icon-no-seat.png": 1034,
	"./icon-no-seat.svg": 1035,
	"./icon-option.svg": 1036,
	"./icon-poin-of-sale.svg": 1037,
	"./icon-recliner.svg": 1038,
	"./icon-report.svg": 1039,
	"./icon-sofa-dark-1.svg": 1040,
	"./icon-sofa-dark.png": 1041,
	"./icon-sofa-dark.svg": 1042,
	"./icon-sofa.svg": 1043,
	"./importfile.svg": 1044,
	"./info.svg": 721,
	"./info2.svg": 1045,
	"./keyboard-icon.svg": 1046,
	"./kitchen_display.svg": 1047,
	"./language-icon.svg": 366,
	"./left-caret.svg": 1048,
	"./link.svg": 1049,
	"./list-view.svg": 1050,
	"./loading.svg": 367,
	"./lock.svg": 1051,
	"./login-password.png": 368,
	"./login-user.png": 369,
	"./logout.svg": 722,
	"./masters-sidebar.svg": 1052,
	"./merchandise.svg": 1053,
	"./minus.svg": 1054,
	"./movie-pass-svg.svg": 712,
	"./movie-rolling.svg": 1055,
	"./mulitSchedule.svg": 1056,
	"./multicurrency.svg": 1057,
	"./multifnb.svg": 1058,
	"./nav-plus.svg": 1059,
	"./new_filter_icon.svg": 1060,
	"./no-image.svg": 1061,
	"./no-schedule.svg": 142,
	"./non-veg-mark.png": 1062,
	"./non-veg-mark.svg": 1063,
	"./notification.svg": 1064,
	"./open-link-blue.svg": 1065,
	"./openPlanned.svg": 1066,
	"./overview.svg": 1067,
	"./overview2.svg": 1068,
	"./pdf-icon.svg": 1069,
	"./pdf.svg": 1070,
	"./pickup-ticket-icon.svg": 1071,
	"./pickupfnb.svg": 1072,
	"./play.svg": 1073,
	"./plus.svg": 1074,
	"./pointofsale-1.svg": 1075,
	"./pointofsale-2.svg": 1076,
	"./pointofsale.png": 1077,
	"./portfolio.svg": 1078,
	"./pos-fnb-no-itmes.svg": 714,
	"./pos-refresh.svg": 1079,
	"./primary/chevron-down.svg": 1080,
	"./primary/download.svg": 1081,
	"./primary/edit.svg": 1082,
	"./primary/filter.svg": 1083,
	"./primary/printer.svg": 1084,
	"./print-icon.svg": 1085,
	"./print.svg": 1086,
	"./question.svg": 1087,
	"./question1.svg": 1088,
	"./question2.svg": 729,
	"./question3.svg": 1089,
	"./recliner-1.svg": 1090,
	"./recliner.png": 1091,
	"./refund-icon.svg": 1092,
	"./reload-icon-pos.svg": 1093,
	"./reload-icon.svg": 1094,
	"./restore.svg": 1095,
	"./right-caret.svg": 1096,
	"./role-management-sidebar.svg": 1097,
	"./save.svg": 1098,
	"./schedule-icon.svg": 1099,
	"./school-calendar.svg": 1100,
	"./search-global-white.svg": 1101,
	"./search-global.svg": 1102,
	"./search.svg": 730,
	"./searchIcon.svg": 1103,
	"./seat-icon-2.svg": 1104,
	"./seat-icon.svg": 1105,
	"./seat-icons/3-wheelChair.png": 1106,
	"./seat-icons/block_seat_new.png": 1107,
	"./seat-icons/broken-seat-1.svg": 1108,
	"./seat-icons/broken-seat-2.svg": 1109,
	"./select-food.png": 731,
	"./settings.svg": 1110,
	"./show-password.svg": 370,
	"./slider-triangle.svg": 723,
	"./snack.svg": 724,
	"./sort.svg": 1111,
	"./star-empty.svg": 1112,
	"./star-fill.svg": 1113,
	"./success-tick.svg": 1114,
	"./suitcase.svg": 1115,
	"./swap.svg": 1116,
	"./tick-green-item.svg": 732,
	"./tick-green.svg": 1117,
	"./ticket-icon.svg": 1118,
	"./trash.svg": 1119,
	"./unpaid-reservation.svg": 706,
	"./updown-white.svg": 1120,
	"./updown.svg": 1121,
	"./user-attribute.svg": 1122,
	"./user-attributes.svg": 1123,
	"./user-female.svg": 1124,
	"./user-male-white.svg": 1125,
	"./user-male.svg": 1126,
	"./user-profile.svg": 1127,
	"./userProfile.png": 1128,
	"./veg-food-mark-white.png": 1129,
	"./veg-foog-mark-trans.png": 1130,
	"./view.png": 1131,
	"./view.svg": 1132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 954;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 954
// module chunks = 37